class LatestEvents {
	constructor() {
		this.events = document.querySelector(".latest-aside .latest-events .swiper");

		if (!this.events) {
			return;
		}

		this.buildEventsSlider();
	}

	buildEventsSlider() {
		this.slider = new Swiper(this.events, {
			navigation: {
				prevEl: ".swiper-prev",
				nextEl: ".swiper-next",
			}
		});
	}
}